// output
module.exports = require("./lib/entry.js");